module.exports = __webpack_public_path__ + "static/media/CTLI_13-315w.70d78f0a.jpg";